import axios, { type InternalAxiosRequestConfig } from 'axios'

import { API_URL } from '@/config'
import storage from '@/utils/storage'

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = storage.getToken()
  const headers = config.headers ?? {}

  if (token) Reflect.set(headers, 'Authorization', token)
  else Reflect.deleteProperty(headers, 'Authorization')

  return config
}

const http = axios.create({
  baseURL: API_URL + '/reimbursements',
})
const httpBase = axios.create({
  baseURL: API_URL,
})

http.interceptors.request.use(authRequestInterceptor)
httpBase.interceptors.request.use(authRequestInterceptor)

export default http
export { httpBase }
